import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class CloudinaryService {
     
    private cloudinary = (window as any).cloudinary;
    
    constructor() {   
    }

    open(success: Function, error?: Function) {
        const widget: any = this.cloudinary.createUploadWidget({
            cloudName: 'dn0lug4cp',
            uploadPreset: 'subscrib.ly',
            cropping: true, //add a cropping step
            // showAdvancedOptions: true,  //add advanced options (public_id and tag)
            // sources: [ "local", "url"], // restrict the upload sources to URL and local files
            // multiple: false,  //restrict upload to a single file
            // folder: "user_images", //upload files to the specified folder
            // tags: ["users", "profile"], //add the given tags to the uploaded files
            // context: {alt: "user_uploaded"}, //add the given context data to the uploaded files
            // clientAllowedFormats: ["images"], //restrict uploading to image files only
            // maxImageFileSize: 2000000,  //restrict file size to less than 2MB
            // maxImageWidth: 2000, //Scales the image down to a width of 2000 pixels before uploading
            // theme: "purple", //change to a purple theme
        }, (err: any, result: any) => {
            if (!error && result && result.event === "success") {
                success(result)
            } else if (error) {
                error(err);
            }
        });
        widget.open();
    }
}


